// 自定义指令
export default {
  increase: { // 自增
    inserted: function (el) {
      console.log('【inserted】 inserted');
      const endText = el.innerText;
      // const endText = el.dataset.value;
      const end = el.innerText*1;
      const step = el.dataset.step;
      el.innerText = 0;
      const timer = setInterval(function() {
        el.innerText = el.innerText*1 + step*1;
        if (el.innerText >= end) {
          clearInterval(timer);
          el.innerText = endText;
        }
      }, 200);
    }
    // update: function() {
    //   console.log('【inserted】 update');
    // }
  },
  // 限制文本框只能输入数字
  inputNumber: {
    bind: function (el) {
      let ele = el.tagName === 'INPUT' ? el : el.querySelector('input');
      ele.addEventListener('input', () => {
        let temp = ele.value;
        temp = temp.replace(/\D/g, '');
        ele.value = temp;
      }, true);
    }
  },
  // 限制文本框只能输入数字、字母、下划线
  inputNumberLetter: {
    bind: function (el) {
      let ele = el.tagName === 'INPUT' ? el : el.querySelector('input');
      ele.addEventListener('input', () => {
        let temp = ele.value;
        temp = temp.replace(/\W/g, '');
        ele.value = temp;
      }, true);
    }
  },
  // 限制文本框只能输入数字或者带两位小数的数字
  inputDecimal: {
    bind: function (el) {
      let ele = el.tagName === 'INPUT' ? el : el.querySelector('input');
      ele.addEventListener('input', () => {
        let temp = ele.value;
        // 先去掉非数字和小数点之外的字符，但保留一个小数点
        temp = temp.replace(/[^\d.]/g, '');
        // 如果第一个字符是小数点，则在前面加0
        if (temp.charAt(0) === '.') {
          temp = '0' + temp;
        }
        // 如果有多个小数点，只保留第一个
        if (temp.indexOf('.') !== -1) {
          let integerPart = temp.substring(0, temp.indexOf('.'));
          let decimalPart = temp.substring(temp.indexOf('.') + 1);
          // 小数部分最多保留两位
          decimalPart = decimalPart.substring(0, 2);
          temp = integerPart + '.' + decimalPart;
        }
        ele.value = temp;
      }, true);
    }
  }
};
